















































































































import { Vue, Component, Prop } from "vue-property-decorator";
import {
  AgDataTableOptions,
  AgDataTableRowMenuOptions,
  AgDataTableColumnOptions
} from "./AgDataTable.vue";

@Component
export default class AgDataTableRow extends Vue {
  @Prop()
  options!: AgDataTableOptions[];

  @Prop()
  index!: number;

  @Prop()
  item!: any;

  @Prop()
  numbered!: boolean;

  parsedOptions: { [key: string]: AgDataTableOptions } = {};
  /**
   * Parses the options prop for faster access based on column key
   */
  created() {
    this.options.forEach(it => {
      this.parsedOptions[it.header.value] = it;
    });
  }
  /**
   * Returns the property of the item corresponding to the column
   * provided as a parameter.
   */
  getValue(column: AgDataTableOptions) {
    return this.item[column.header.value];
  }

  columnType(key: string) {
    return this.parsedOptions[key]
      ? this.parsedOptions[key].row.type
      : undefined;
  }
  /**
   * Returns the color class based on the property value.
   */
  getColor(column: AgDataTableOptions) {
    if (column.row.type == "CHIP" && typeof column.row.color === "object") {
      return column.row.color[this.getValue(column)] || "";
    } else {
      return "";
    }
  }
  /**
   *  URL interpolator. Replaces all strings between curly braces for the
   *  corresponding property of the object.
   */
  getPath(expression: string) {
    let expr = String(expression);
    const tokens = expr.match(/{(.*?)}+/g);
    if (tokens)
      tokens.forEach(token => {
        let prop = token.replace(/[{}]/g, "");
        if (prop.startsWith("$")) {
          prop = prop.slice(1);
          expr = expr.replace(token, this.$route.params[prop]);
        } else {
          expr = expr.replace(token, this.item[prop]);
        }
      });
    return expr;
  }
  /**
   * Executes a route push or provided function
   */
  execute(opts: AgDataTableRowMenuOptions, column: AgDataTableColumnOptions) {
    if (opts.link) {
      this.$router.push({
        path: this.getPath(opts.link),
        replace: !!opts.replace,
        append: !!opts.append
      });
    } else if (opts.action) {
      opts.action(this.item, column);
    }
  }
}
